/** Current number of NFL teams */
export const NFL_TEAMS_TOTAL = 32;

/** NFL regular season weeks */
export const NFL_WEEKS_TOTAL = 18;

/** 18 weeks - 1 byeweek = 17 x 32 teams / 2 (takes two to tango) */
export const NFL_GAMES_PER_SEASON = 272;

/** Approximate number of days since the last NFL season ended */
export const DAYS_SINCE_LAST_SEASON = 210;

/** Non-breaking space character */
export const NBSP = '\u00A0';
